import React, {useMemo} from 'react';
import { Button } from '@mui/material';
import SpaceBarIcon from '@mui/icons-material/SpaceBar';
import AddIcon from '@mui/icons-material/Add';
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";

import workspaceControllers from "../../../canvas/store/workspaceControllers";
import FeatureName from "../../../../../visComponents/featureName";
import {getCurrentLayout} from "../../../../../appLayout";
import {setFeaturePicker} from "../../../../../../actions/sqftMenuFunctions";
import {CABINET_FILTER_NAMES, FEATURE_PICKER_TYPE, SQFT_FEATURES} from "../../../../constants";
import ConfirmButtons from "./ConfirmButtons";
import workspace from "../../../canvas/core/workspace";

const Handles = (props) => {
  const {sqftActiveShapeId, featurePicker, setFeaturePicker, resourceControllerCounter, selectedFeatureInPicker} = props;

  const lineHandlesModels = useMemo(() => {
    return workspaceControllers.handles.getAllResourcesForTheShape(sqftActiveShapeId)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resourceControllerCounter]);

  const hasHandles = lineHandlesModels.length > 0;

  const openHandlePicker = (lineHandlesModel, isAdding) => {
    const pickerData = {
      isOpen: true,
      partIds: [SQFT_FEATURES.top_handle],
      shapeId: sqftActiveShapeId,
      type: FEATURE_PICKER_TYPE.handles,
      isAdding: isAdding
    };

    if (!isAdding && lineHandlesModel) {
      pickerData.modelId = lineHandlesModel.id;
      pickerData.featureId = lineHandlesModel.featureId;
      pickerData.sharedFeatureName = lineHandlesModel.sharedFeatureName;
    }

    setFeaturePicker(pickerData);
  }

  const confirmCallback = () => {
    if (featurePicker.isAdding) {
      const shape = workspace.getShapeById(sqftActiveShapeId);
      const selectedHandle = layout.getFeatureById(selectedFeatureInPicker);
      shape.shapeCabinet.generateAttachedFeatures(CABINET_FILTER_NAMES.knobs, { knobs: selectedHandle });
      workspaceControllers.hinge.updateReduxCounterOnChange();
    } else {
      const lineHandleModel = workspaceControllers.handles.getResourceById(featurePicker.modelId);
      const layout = getCurrentLayout();
      const handlesFeatureGroup = layout.getFeatureGroupByPartId(lineHandleModel.partId);
      const selectedHandle = layout.getFeatureById(selectedFeatureInPicker);
      const handleFeature = handlesFeatureGroup.features.find(feature =>
        feature.getFeatureName() === selectedHandle.getFeatureName()
      );
      lineHandleModel.changeFeature(handleFeature);
    }

    setFeaturePicker({ isOpen: false, partIds: [], shapeId: '', type: '', isAdding: false });
  }

  const cancelCallback = () => {
    setFeaturePicker({ isOpen: false, partIds: [], shapeId: '', type: '', isAdding: false });
  }

  const layout = getCurrentLayout();

  return (
    <div className="sr__section sr__handles">
      <div className="sr__section-title">
        <FormattedMessage id="Handles"/>
      </div>
      {
        hasHandles ? (
          lineHandlesModels.map((lineHandlesModel, index) => {
            const handleFeature = layout.getFeatureById(lineHandlesModel.featureId, true);

            return (
              <div className="handles__item" key={index}>
                <label className="handles__label">
                  <FeatureName feature={handleFeature} />
                </label>
                {
                  featurePicker.isOpen
                  && featurePicker.modelId === lineHandlesModel.id
                  && featurePicker.type === FEATURE_PICKER_TYPE.handles
                    ? <ConfirmButtons confirmCallback={confirmCallback} cancelCallback={cancelCallback}/>
                    : <Button
                      className={"sr__button handles__button"}
                      onClick={() => openHandlePicker(lineHandlesModel, false)}
                      variant="outlined"
                      color="primary"
                      startIcon={<SpaceBarIcon style={{transform: 'rotate(180deg)'}}/>}
                    >
                      <FormattedMessage id="CHANGE HANDLE"/>
                    </Button>
                }
              </div>
            )
          })
        ) : (
          <div className="handles__item">
            {
              featurePicker.isOpen
              && featurePicker.type === FEATURE_PICKER_TYPE.handles
              && featurePicker.isAdding
                ? <ConfirmButtons confirmCallback={confirmCallback} cancelCallback={cancelCallback}/>
                : <Button
                  className={"sr__button handles__button"}
                  onClick={() => openHandlePicker(null, true)}
                  variant="outlined"
                  color="primary"
                  startIcon={<AddIcon />}
                >
                  <FormattedMessage id="Add Handle"/>
                </Button>
            }
          </div>
        )
      }
    </div>
  );
};

const mapStateToProps = (store) => ({
  sqftActiveShapeId: store.sqftMenuState.sqftActiveShapeId,
  featurePicker: store.sqftMenuState.featurePicker,
  selectedFeatureInPicker: store.sqftMenuState.selectedFeatureInPicker,
  resourceControllerCounter: store.sqftResourceState.resourceControllerCounter,
});

const mapDispatchToProps = {
  setFeaturePicker
};

export default connect(mapStateToProps, mapDispatchToProps)(Handles);
